export const DEFAULT_TABS = {
  ALL: 'All',
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
};
